import { observable } from 'mobx';
import type { Moment } from 'moment';
import moment from 'moment-timezone';

export type TransportElementTerminalResponseArgs = {
  id: number;
  name: string;
  time: string;
  time_zone: string;
  code?: string;
};

export type TransportElementTerminalArgs = {
  id?: number;
  name?: string;
  time: Moment;
  timeZone: string;
  code?: string;
};

export const convertTransportElementTerminalResponseToArgs = (response: TransportElementTerminalResponseArgs) => {
  const args: TransportElementTerminalArgs = {
    id: response.id,
    name: response.name,
    // 現地時間で表示するため
    time: moment(response.time).tz(response.time_zone),
    timeZone: response.time_zone,
    code: response.code
  };
  return args;
};

export default class TransportElementTerminal {
  @observable id?: number;
  @observable name?: string;
  @observable time: Moment;
  @observable timeZone: string;
  @observable code?: string;

  constructor(args: TransportElementTerminalArgs) {
    this.id = args.id;
    this.name = args.name;
    this.time = args.time;
    this.timeZone = args.timeZone;
    this.code = args.code;
  }

  get description() {
    const time = this.time.clone();
    return `${this.name || ''} ${time.tz(this.timeZone).format('YYYY/MM/DD HH:mm')}`;
  }

  get foreignAirDescription() {
    const time = this.time.clone();
    return `${time.tz(this.timeZone).format('YYYY/MM/DD HH:mm')} ${this.name}`;
  }

  get updateParams() {
    // this.time（Moment）がmutableのため.this.timeは変えないようにcloneを挟む
    const time = this.time.clone();
    return {
      id: this.id,
      name: this.name,
      time: time.tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm'),
      time_zone: this.timeZone,
      code: this.code
    };
  }

  get dateStr() {
    return `${this.time.tz(this.timeZone).format('YYYY-MM-DD')}`;
  }
}
